<template>
  <div class="free-shipping-notification">
    <p
      class="free-shipping-notification__header"
      v-text="progressMessage"
    />

    <div class="free-shipping-notification__track">
      <div
        class="free-shipping-notification__track-inner"
        :style="{ width: progressWidth }"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Free shipping notification (free-shipping-notification)
 * -----------------------------------------------------------------------------
 * Progress bar showing how much until free shipping is applied.
 *
 * @param {Number} freeShippingThreshold - Dollar amount for free shipping.
 *
 */

import { mapState } from 'vuex'

export default {
  name: 'FreeShippingNotification',

  props: {
    freeShippingThreshold: {
      type: Number,
      default: 50,
    },
  },

  data() {
    return {
      progressMessage: '',
      progressWidth: 0,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    /**
     * Local currency converted shipping threshold
     */
    localizedFreeShippingThreshold() {
      if (!window.Shopify.currency) {
        return this.freeShippingThreshold
      }

      const amount = this.freeShippingThreshold * window.Shopify.currency.rate

      // eslint-disable-next-line
      return +(Math.round(amount + "e+2")  + "e-2")
    },
  },

  watch: {
    cart(data) {
      this.updateProgress(data)
    },
  },

  mounted() {
    this.updateProgress(this.cart)
  },

  methods: {

    /**
     * Update progress bar and messaging when cart updates.
     * @param {Object} cartData - Cart data.
     */
    updateProgress(cartData) {
      const dollars = cartData.total_price / 100

      if (dollars > this.localizedFreeShippingThreshold) {
        this.progressWidth = '100%'
        this.progressMessage = this.$string('product.extra.free_shipping_success')

        return
      }

      const percentage = (dollars / this.localizedFreeShippingThreshold) * 100
      const remaining = (this.localizedFreeShippingThreshold - dollars) * 100

      this.progressWidth = `${percentage}%`
      this.progressMessage =
        this.$string('product.extra.free_shipping_header')
          .replace('{{ amount }}', this.$formatMoney(remaining))
    },
  },
}
</script>
